import { Dialog, DialogContent, DialogTitle } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";

const EtradeAccSelection = ({ open, onClose }) => {
    const [selectAcc, setSelectAcc] = useState('');
    const [errors, setErrors] = useState({ selectAcc: ''});
    const [loading, setLoading] = useState(false);
    const {etradeAllAccData, updateUserData, integrationsParams, aiSettings, userData, holdingsData, getOrderData, accountsSummary, getWatchLists} = useContext(AuthContext);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const allAcc = etradeAllAccData?.AccountListResponse?.Accounts?.Account || [];
        // console.log(etradeAllAccData );
        
        setOptions(allAcc);
    },[etradeAllAccData]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log(selectAcc);
        

        let valid = true;
        let newErrors = { ...errors };

        if (!selectAcc) {
            console.log('no selectAcc');
            newErrors.selectAcc = 'Please select any one account';
            valid = false;
            setErrors(newErrors);
            return;
        }    
        setLoading(true);

        if (valid) {
            const updatedSettings = {
                ...(Object.keys(integrationsParams).length > 0
                  ? integrationsParams
                  : userData?.integrations || {}),
                  trade_account_id: selectAcc.accountIdKey, 
                  trade_ins_type: selectAcc.institutionType,
            };
            await aiSettings(updatedSettings);
            await holdingsData(userData.integrations?.current_integration, selectAcc.accountIdKey);
            await getOrderData(userData.integrations?.current_integration, selectAcc.accountIdKey);
            await getWatchLists(userData.integrations?.current_integration, selectAcc.accountIdKey);
            await accountsSummary(userData.integrations?.current_integration, selectAcc.accountIdKey, selectAcc.institutionType);
            setLoading(false);
            setErrors('');
            setSelectAcc('');
            onClose(); 
        }
    };

    const handleClose = () => {
        setLoading(false);
        setErrors('');
        setSelectAcc('');
        onClose(); 
    };

    return(
        <Dialog open={open} onClose={onClose} aria-labelledby="settings-dialog-title" fullWidth PaperProps={{
            style: {
              width: '500px',
              maxWidth: '100%',
            },
        }} className="setting-dialog">
            <DialogTitle id="settings-dialog-title" className="d-flex justify-content-between mb-4">
                <div className="d-flex align-items-center">
                    <span style={{marginLeft:"6px"}}>E*Trade Account</span>
                </div>
              <img style={{ float: 'none', height: "22px", width: "20px" }} src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={handleClose} />
            </DialogTitle>

            <DialogContent>
                <Form onSubmit={handleSubmit} className="basic-form">
                    <div className="mb-2">
                        <span style={{fontSize: "16px"}}>Select Account</span>
                    </div>

                    <Form.Group>
                        <Form.Control
                            as="select"
                            className="form-input custom-select"
                            value={selectAcc ? JSON.stringify(selectAcc) : ""}
                            onChange={(e) => {
                                const selectedOption = JSON.parse(e.target.value);
                                setSelectAcc(selectedOption);
                                if (selectedOption) {
                                    setErrors((prevErrors) => ({ ...prevErrors, selectAcc: '' })); // Remove error
                                }
                            }}>
                            <option value="">Select your E*Trade Account</option>
                            {options.map((option) => (
                                <option
                                    key={option.accountIdKey}
                                    value={JSON.stringify(option)} // Store full object
                                >
                                    {option.accountDesc}, {option.institutionType}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    {errors.selectAcc && <div className="text-danger mt-1">{errors.selectAcc}</div>}

                    <div className="mt-2 row justify-content-center">
                        <Button variant="primary" type="submit" style={{backgroundColor: '#48494C', textTransform: 'none', border:'none'}} className="mt-5 w-55 p-2 theme-btn-email" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </Button>
                    </div>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

export default EtradeAccSelection;